import { ReactNode } from "react";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { GOOGLE_CLIENT_ID } from "constants/env";

import store from "store/reducers";

import { ScreenProvider } from "context/screen";
import { AuthProvider } from "context/auth";
import { CommonProvider } from "context/common";

import { useDocumentLang } from "hooks/useDocumentLang";

import { SessionProvider } from "components/SessionProvider";

export function AppProviders({ children }: { children: ReactNode }) {
  useDocumentLang();

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <CommonProvider>
          <ScreenProvider>
            <AuthProvider>
              <SessionProvider>
                {children}
              </SessionProvider>
            </AuthProvider>
          </ScreenProvider>
        </CommonProvider>
      </Provider>
    </GoogleOAuthProvider>
  );
}
